import React, { useState } from 'react';
import axios from 'axios';

const RESET_API = 'https://oppiesfunc.azurewebsites.net/api/resetPassword?code=ZHGHIY9848KPO_pOFRI19FcIi1brx8_BW6_U6lBU2KIvAzFu7bp9Ug==';

function ResetPassword() {
    const [email, setEmail] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [status, setStatus] = useState('');

    const handleReset = async () => {
        if (!email || !newPassword) {
            setStatus('Please enter both email and new password.');
            return;
        }

        try {
            const response = await axios.post(RESET_API, { email, newPassword });
            setStatus(response.data.message || 'Password reset successfully.');
        } catch (err) {
            setStatus(err.response?.data?.error || 'Failed to reset password.');
        }
    };

    return (
        <div style={styles.container}>
            <h2>Reset User Password</h2>
            <input
                type="email"
                placeholder="User email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={styles.input}
            />
            <input
                type="password"
                placeholder="New password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                style={styles.input}
            />
            <button onClick={handleReset} style={styles.button}>
                Reset Password
            </button>
            {status && <p>{status}</p>}
        </div>
    );
}

const styles = {
    container: {
        padding: 30,
        maxWidth: 500,
        margin: '50px auto',
        background: '#fdfdfd',
        borderRadius: 10,
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    },
    input: {
        width: '100%',
        padding: 12,
        fontSize: 16,
        marginBottom: 15,
        borderRadius: 6,
        border: '1px solid #ccc',
    },
    button: {
        padding: '10px 20px',
        fontSize: 16,
        borderRadius: 6,
        background: '#bfa97c',
        color: '#fff',
        border: 'none',
        cursor: 'pointer',
    },
};

export default ResetPassword;
